export const environment = {
  production: false,
  // apiUrl: 'http://192.168.0.112:8000/'
    apiUrl: 'https://test-audit-api.classcover.com.au/',
    client_id: '520b1ce8-e8e0-401f-a863-ebde5aa57cc6',
    client_secret: 'f9i8Q~Tdt64Ht-IGC2Lh6_jbe88p7RrDIdooIaYM',
    cookiesDomain: 'classcover.com.au' // change to your domain for cookies
};
